import { createFileRoute } from '@tanstack/react-router';

import { AutoSkipCitationsSection } from '@/components/astro/new-design/sections/auto-skip-citations';
import { BrandLogosSection } from '@/components/astro/new-design/sections/brand-logos';
import { CustomerTestimonialsShortSection } from '@/components/astro/new-design/sections/customer-testimonials-short';
import { EduBannerSection } from '@/components/astro/new-design/sections/edu-banner';
import { FaqSection } from '@/components/astro/new-design/sections/faq';
import { FeaturesCardSection } from '@/components/astro/new-design/sections/features-card';
import { HeroHeadingSection } from '@/components/astro/new-design/sections/hero-heading';
import { PricingComparisonSection } from '@/components/astro/new-design/sections/pricing-comparison';
import { ProductOverflowImageSection } from '@/components/astro/new-design/sections/product-overflow-image';
import { SaveTimeByChoosingSection } from '@/components/astro/new-design/sections/save-time-by-choosing';
import { SoundsNaturalEvenAtSpeedSection } from '@/components/astro/new-design/sections/sounds-natural-even-at-speed';
import { TakeNotesOnTheGoSection } from '@/components/astro/new-design/sections/take-notes-on-the-go';
import { VoiceDemoSection } from '@/components/astro/new-design/sections/voice-demo';
import { WhatDoPeopleThinkSection } from '@/components/astro/new-design/sections/what-do-people-think';
import { WorldClassListeningSection } from '@/components/astro/new-design/sections/world-class-listening';
import { Footer } from '@/components/astro/new-design-25/ui/Footer';
import { NavBar } from '@/components/astro/new-design-25/ui/NavBar';
import { seo } from '@/seo/seo';

export const Route = createFileRoute('/_marketing/_seo/_legacy/ref')({
  head: () => ({
    meta: [
      ...seo({
        title: 'Need more info about the page',
        description:
          'Revolutionize your study habits by listening to academic research on the go. Start your journey today and experience learning like never before!',
      }),
    ],
  }),
  component: () => (
    <>
      <h1 className='sr-only'>Need more info about the page</h1>
      <div className='absolute inset-x-0 top-0 h-[30vh] bg-[linear-gradient(rgba(21,_112,_239,_.2),_rgba(255,_255,_255,_0))]' />

      <NavBar />
      <HeroHeadingSection />
      <EduBannerSection />
      <BrandLogosSection />
      <VoiceDemoSection />
      <CustomerTestimonialsShortSection />
      <ProductOverflowImageSection />
      <WorldClassListeningSection />
      <TakeNotesOnTheGoSection />
      <AutoSkipCitationsSection />
      <SaveTimeByChoosingSection />
      <SoundsNaturalEvenAtSpeedSection />
      <WhatDoPeopleThinkSection />
      <PricingComparisonSection />
      <FeaturesCardSection />
      <FaqSection />
      <Footer />
    </>
  ),
});
